module.exports = __webpack_public_path__ + "static/media/img_propose_b_device.87cd034e.png";